import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/fontawesome-free-solid';

class Loader extends Component {

    render() {
        return (
            <div className="text-center">
                <FontAwesomeIcon size='4x' icon={faSpinner} spin />
            </div>
        );
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/js/Loader.js